var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"-Copy-16",
    transform: "translate(-22.000000, -193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#269325",
    transform: "translate(15.000000, 15.000000) rotate(90.000000) translate(-15.000000, -15.000000) ",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    points: "8 14.9827725 12.9941696 20 23 10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperGroup);
export default __webpack_public_path__ + "static/media/stepper_group.35da2270a94493e69de52800808c5eff.svg";
export { ForwardRef as ReactComponent };